import * as sendTyping from './reducers/send-typing';
import * as getChat from './reducers/get-chat';
import * as sendMessage from './reducers/send-message';
import * as assignChat from './reducers/assign-chat';
import * as unassignChat from './reducers/unassign-chat';
import * as endChat from './reducers/end-chat';
import * as disableChat from './reducers/disable-chat';
import * as getDisableChat from './reducers/get-disable-chat';
import * as deleteMessage from './reducers/delete-message';

// eslint-disable-next-line import/no-default-export
export default {
    TRADER_CHAT_TYPING_START: sendTyping.start,
    TRADER_CHAT_TYPING_STOP: sendTyping.stop,
    TRADER_CHAT_GET_CHAT_REQUEST: getChat.request,
    TRADER_CHAT_SEND_MESSAGE_REQUEST: sendMessage.request,
    TRADER_CHAT_ASSIGN_CHAT_REQUEST: assignChat.request,
    TRADER_CHAT_UNASSIGN_CHAT_REQUEST: unassignChat.request,
    TRADER_CHAT_END_CHAT_REQUEST: endChat.request,
    TRADER_CHAT_DISABLE_CHAT_REQUEST: disableChat.request,
    TRADER_CHAT_GET_DISABLE_CHAT_REQUEST: getDisableChat.request,
    TRADER_CHAT_DELETE_MESSAGE_REQUEST: deleteMessage.request,
};
